import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daelq31tto0ceqqngvo0";

const tipTypes = ["明星动态", "影视综艺", "社会热点", "网红世界", "其他爆料"];

const baseError =
  "抱歉，这条爆料暂时没能提交成功，请稍后再试或直接与我们联系。";

export default function ReportSection() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const content = (data.get("content") as string) || "";

    if (content.length > 500) {
      setFormError("爆料内容不能超过 500 字，请精简后重新提交。");
      setStatus("error");
      return;
    }

    // 蜜罐字段：若被自动填充则静默放行，不向表单地址发送任何数据
    const honeypot = (data.get("website_alt") as string) || "";
    const payload = new FormData();
    const fieldNames = ["nickname", "email", "topic", "content"];
    fieldNames.forEach((f) => {
      const v = data.get(f);
      if (v) payload.append(f, v as string);
    });

    setSubmitting(true);
    setStatus("idle");
    setFormError("");

    if (honeypot.trim() !== "") {
      // 机器人：直接给出与正常一致的成功反馈
      setSubmitting(false);
      setStatus("success");
      return;
    }

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.code || "";
      const isSpam =
        /spam/i.test(responseText) || /spam/i.test(serverMsg) || /spam/i.test(parsed?.code || "");

      if (!res.ok || !parsed || parsed.code !== "OK" || isSpam) {
        setFormError(serverMsg && serverMsg !== "OK" ? serverMsg : baseError);
        setStatus("error");
        return;
      }
      setStatus("success");
      form.reset();
      setCharCount(0);
    } catch {
      setFormError(baseError);
      setStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="report"
      className="scroll-mt-24 w-full bg-background-100 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="grid grid-cols-1 overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:grid-cols-12">
          <div className="relative flex flex-col justify-center bg-primary-800 p-7 md:p-10 lg:col-span-5">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-600/30 to-primary-900/40" />
            <div className="relative z-10">
              <span className="flex w-fit items-center gap-2 rounded-full bg-accent-400/20 px-3 py-1 text-xs font-medium text-accent-200">
                <i className="ri-megaphone-line h-4 w-4 flex items-center justify-center" />
                在线投稿 · 线索保密
              </span>
              <h2 className="mt-4 font-display text-2xl font-bold text-background-50 md:text-3xl">
                你有瓜，我来查
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-primary-100/90">
                蹲到新鲜瓜点、觉得某件事被误传、或掌握可靠线索？
                欢迎告诉我们。编辑部会核实素材与信源，
                经你同意后再整理发布，并对提供者严格保密。
              </p>
              <ul className="mt-6 space-y-3 text-sm text-primary-100/90">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line h-5 w-5 flex items-center justify-center text-accent-300" />
                  尽量描述时间、地点与事件经过
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line h-5 w-5 flex items-center justify-center text-accent-300" />
                  附上可核实线索，报道会更扎实
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line h-5 w-5 flex items-center justify-center text-accent-300" />
                  工作日 24 小时内会收到回复
                </li>
              </ul>
              <div className="mt-7 flex items-center gap-3 rounded-lg bg-primary-900/50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                  <i className="ri-mail-send-line h-5 w-5 flex items-center justify-center" />
                </span>
                <div className="text-xs text-primary-100/80">
                  <p className="font-medium text-background-50">合作与反馈邮箱</p>
                  <p className="mt-0.5">contact@99chigua.example</p>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-10 lg:col-span-7">
            <p className="text-sm font-semibold text-foreground-900">在线提交你的爆料线索</p>
            <p className="mt-1 text-xs text-foreground-500">
              请据实填写，标注明确的字段会帮助我们更快核实。
            </p>

            <form
              data-readdy-form="吃瓜投稿爆料表单"
              onSubmit={handleSubmit}
              className="mt-6 space-y-5"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-note-field"
              />
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="nickname" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    你的昵称
                  </label>
                  <input
                    id="nickname"
                    name="nickname"
                    type="text"
                    required
                    maxLength={30}
                    placeholder="怎么称呼你"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-300 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    联系邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder="用于接收回复"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-300 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="topic" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  事件类型
                </label>
                <select
                  id="topic"
                  name="topic"
                  required
                  defaultValue=""
                  className="w-full rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                >
                  <option value="" disabled>
                    请选择事件所属栏目
                  </option>
                  {tipTypes.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <div className="mb-1.5 flex items-center justify-between">
                  <label htmlFor="content" className="text-sm font-medium text-foreground-800">
                    爆料内容
                  </label>
                  <span className="text-xs text-foreground-400">{charCount}/500</span>
                </div>
                <textarea
                  id="content"
                  name="content"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="请尽量描述时间、地点、人物与事件经过，我们会保守地整理后再发布……"
                  onChange={(ev) => setCharCount(ev.target.value.length)}
                  className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm leading-relaxed text-foreground-900 outline-none transition-colors placeholder:text-foreground-300 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
              </div>

              {status === "error" && (
                <div
                  role="alert"
                  className="flex items-start gap-2 rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-sm text-primary-800"
                >
                  <i className="ri-error-warning-line mt-0.5 h-4 w-4 flex items-center justify-center shrink-0" />
                  {formError}
                </div>
              )}
              {status === "success" && (
                <div
                  role="status"
                  className="flex items-start gap-2 rounded-md border border-accent-300 bg-accent-50 px-4 py-3 text-sm text-accent-800"
                >
                  <i className="ri-checkbox-circle-line mt-0.5 h-4 w-4 flex items-center justify-center shrink-0" />
                  收到！你的爆料线索已提交成功，编辑部会尽快核实并与你联系。
                </div>
              )}

              <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="submit"
                  disabled={submitting}
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {submitting ? (
                    <>
                      <i className="ri-loader-4-line h-4 w-4 flex items-center justify-center animate-spin" />
                      提交中…
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line h-4 w-4 flex items-center justify-center" />
                      提交线索
                    </>
                  )}
                </button>
                <p className="text-xs leading-relaxed text-foreground-400">
                  提交即表示你同意我们为核实目的在站内使用该线索。
                  <br className="hidden sm:block" />
                  未经你的同意，我们不会公开你的个人信息。
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}